import { render, staticRenderFns } from "./edit-survey.component.html?vue&type=template&id=71a37fac&scoped=true&"
import script from "./edit-survey.component.ts?vue&type=script&lang=ts&"
export * from "./edit-survey.component.ts?vue&type=script&lang=ts&"
import style0 from "./edit-survey.component.scss?vue&type=style&index=0&id=71a37fac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a37fac",
  null
  
)

export default component.exports